var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-9",staticStyle:{"height":"150px","padding-top":"0px"},attrs:{"id":"playlist-items"}},[_c('div',{staticClass:"not-found text-muted"},[_c('i',{staticClass:"las la-exclamation-circle"}),_vm._v(" No\n                               "+_vm._s(_vm.type)+"s Found in Playlist")])])
}
var staticRenderFns = []

export { render, staticRenderFns }